/* tslint:disable */
/* eslint-disable */
/**
 * EVE Swagger Interface
 * An OpenAPI for EVE Online
 *
 * The version of the OpenAPI document: 1.30
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetLoyaltyStoresCorporationIdOffersRequiredItem } from './GetLoyaltyStoresCorporationIdOffersRequiredItem';
import {
    GetLoyaltyStoresCorporationIdOffersRequiredItemFromJSON,
    GetLoyaltyStoresCorporationIdOffersRequiredItemFromJSONTyped,
    GetLoyaltyStoresCorporationIdOffersRequiredItemToJSON,
    GetLoyaltyStoresCorporationIdOffersRequiredItemToJSONTyped,
} from './GetLoyaltyStoresCorporationIdOffersRequiredItem';

/**
 * 200 ok object
 * @export
 * @interface GetLoyaltyStoresCorporationIdOffers200Ok
 */
export interface GetLoyaltyStoresCorporationIdOffers200Ok {
    /**
     * Analysis kredit cost
     * @type {number}
     * @memberof GetLoyaltyStoresCorporationIdOffers200Ok
     */
    akCost?: number;
    /**
     * isk_cost integer
     * @type {number}
     * @memberof GetLoyaltyStoresCorporationIdOffers200Ok
     */
    iskCost: number;
    /**
     * lp_cost integer
     * @type {number}
     * @memberof GetLoyaltyStoresCorporationIdOffers200Ok
     */
    lpCost: number;
    /**
     * offer_id integer
     * @type {number}
     * @memberof GetLoyaltyStoresCorporationIdOffers200Ok
     */
    offerId: number;
    /**
     * quantity integer
     * @type {number}
     * @memberof GetLoyaltyStoresCorporationIdOffers200Ok
     */
    quantity: number;
    /**
     * required_items array
     * @type {Array<GetLoyaltyStoresCorporationIdOffersRequiredItem>}
     * @memberof GetLoyaltyStoresCorporationIdOffers200Ok
     */
    requiredItems: Array<GetLoyaltyStoresCorporationIdOffersRequiredItem>;
    /**
     * type_id integer
     * @type {number}
     * @memberof GetLoyaltyStoresCorporationIdOffers200Ok
     */
    typeId: number;
}

/**
 * Check if a given object implements the GetLoyaltyStoresCorporationIdOffers200Ok interface.
 */
export function instanceOfGetLoyaltyStoresCorporationIdOffers200Ok(value: object): value is GetLoyaltyStoresCorporationIdOffers200Ok {
    if (!('iskCost' in value) || value['iskCost'] === undefined) return false;
    if (!('lpCost' in value) || value['lpCost'] === undefined) return false;
    if (!('offerId' in value) || value['offerId'] === undefined) return false;
    if (!('quantity' in value) || value['quantity'] === undefined) return false;
    if (!('requiredItems' in value) || value['requiredItems'] === undefined) return false;
    if (!('typeId' in value) || value['typeId'] === undefined) return false;
    return true;
}

export function GetLoyaltyStoresCorporationIdOffers200OkFromJSON(json: any): GetLoyaltyStoresCorporationIdOffers200Ok {
    return GetLoyaltyStoresCorporationIdOffers200OkFromJSONTyped(json, false);
}

export function GetLoyaltyStoresCorporationIdOffers200OkFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLoyaltyStoresCorporationIdOffers200Ok {
    if (json == null) {
        return json;
    }
    return {
        
        'akCost': json['ak_cost'] == null ? undefined : json['ak_cost'],
        'iskCost': json['isk_cost'],
        'lpCost': json['lp_cost'],
        'offerId': json['offer_id'],
        'quantity': json['quantity'],
        'requiredItems': ((json['required_items'] as Array<any>).map(GetLoyaltyStoresCorporationIdOffersRequiredItemFromJSON)),
        'typeId': json['type_id'],
    };
}

export function GetLoyaltyStoresCorporationIdOffers200OkToJSON(json: any): GetLoyaltyStoresCorporationIdOffers200Ok {
    return GetLoyaltyStoresCorporationIdOffers200OkToJSONTyped(json, false);
}

export function GetLoyaltyStoresCorporationIdOffers200OkToJSONTyped(value?: GetLoyaltyStoresCorporationIdOffers200Ok | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ak_cost': value['akCost'],
        'isk_cost': value['iskCost'],
        'lp_cost': value['lpCost'],
        'offer_id': value['offerId'],
        'quantity': value['quantity'],
        'required_items': ((value['requiredItems'] as Array<any>).map(GetLoyaltyStoresCorporationIdOffersRequiredItemToJSON)),
        'type_id': value['typeId'],
    };
}

